import { render, staticRenderFns } from "./editShopHouse.vue?vue&type=template&id=6fbd12f8"
import script from "./editShopHouse.vue?vue&type=script&lang=js"
export * from "./editShopHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports